"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = void 0;
exports.getUrlParam = getUrlParam;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.regexp.replace.js");
require("core-js/modules/es6.regexp.constructor.js");
require("core-js/modules/es6.regexp.search.js");
var _size = _interopRequireDefault(require("lodash/size"));
function cov_24d4r910yx() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/urlHelper.js";
  var hash = "4030021ba2ec9e25dee61218d0a48bfdfbb7930c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/urlHelper.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 24
        },
        end: {
          line: 4,
          column: 54
        }
      },
      "1": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 6,
          column: 67
        }
      },
      "2": {
        start: {
          line: 7,
          column: 18
        },
        end: {
          line: 7,
          column: 33
        }
      },
      "3": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 28
        }
      },
      "4": {
        start: {
          line: 9,
          column: 16
        },
        end: {
          line: 9,
          column: 28
        }
      },
      "5": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 29
        }
      },
      "6": {
        start: {
          line: 10,
          column: 19
        },
        end: {
          line: 10,
          column: 29
        }
      },
      "7": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 60
        }
      },
      "8": {
        start: {
          line: 24,
          column: 24
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "9": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "10": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 14
        }
      },
      "11": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "12": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 19
        }
      },
      "13": {
        start: {
          line: 32,
          column: 15
        },
        end: {
          line: 32,
          column: 46
        }
      },
      "14": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "15": {
        start: {
          line: 34,
          column: 23
        },
        end: {
          line: 34,
          column: 34
        }
      },
      "16": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 45,
          column: 5
        }
      },
      "17": {
        start: {
          line: 36,
          column: 22
        },
        end: {
          line: 36,
          column: 58
        }
      },
      "18": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 44,
          column: 7
        }
      },
      "19": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 77
        }
      },
      "20": {
        start: {
          line: 39,
          column: 13
        },
        end: {
          line: 44,
          column: 7
        }
      },
      "21": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 62
        }
      },
      "22": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 45
        }
      },
      "23": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 89
        }
      },
      "24": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 47,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "getUrlParam",
        decl: {
          start: {
            line: 3,
            column: 16
          },
          end: {
            line: 3,
            column: 27
          }
        },
        loc: {
          start: {
            line: 3,
            column: 39
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 24
          },
          end: {
            line: 24,
            column: 25
          }
        },
        loc: {
          start: {
            line: 24,
            column: 50
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 30
          },
          end: {
            line: 33,
            column: 31
          }
        },
        loc: {
          start: {
            line: 33,
            column: 37
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 28
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 10
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 24,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 24,
            column: 35
          },
          end: {
            line: 24,
            column: 37
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 25
      },
      "4": {
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 22
          }
        }, {
          start: {
            line: 25,
            column: 26
          },
          end: {
            line: 25,
            column: 53
          }
        }],
        line: 25
      },
      "5": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 28
      },
      "6": {
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 13
          }
        }, {
          start: {
            line: 28,
            column: 17
          },
          end: {
            line: 28,
            column: 35
          }
        }],
        line: 28
      },
      "7": {
        loc: {
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 34
          },
          end: {
            line: 32,
            column: 36
          }
        }, {
          start: {
            line: 32,
            column: 39
          },
          end: {
            line: 32,
            column: 46
          }
        }],
        line: 32
      },
      "8": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 35
      },
      "9": {
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 32
          }
        }, {
          start: {
            line: 35,
            column: 36
          },
          end: {
            line: 35,
            column: 55
          }
        }],
        line: 35
      },
      "10": {
        loc: {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        }, {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 44,
            column: 7
          }
        }],
        line: 37
      },
      "11": {
        loc: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 24
          }
        }, {
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 43
          }
        }],
        line: 37
      },
      "12": {
        loc: {
          start: {
            line: 38,
            column: 29
          },
          end: {
            line: 38,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 47
          },
          end: {
            line: 38,
            column: 49
          }
        }, {
          start: {
            line: 38,
            column: 52
          },
          end: {
            line: 38,
            column: 55
          }
        }],
        line: 38
      },
      "13": {
        loc: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 44,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 44,
            column: 7
          }
        }, {
          start: {
            line: 41,
            column: 13
          },
          end: {
            line: 44,
            column: 7
          }
        }],
        line: 39
      },
      "14": {
        loc: {
          start: {
            line: 43,
            column: 30
          },
          end: {
            line: 43,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 56
          },
          end: {
            line: 43,
            column: 59
          }
        }, {
          start: {
            line: 43,
            column: 62
          },
          end: {
            line: 43,
            column: 65
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4030021ba2ec9e25dee61218d0a48bfdfbb7930c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24d4r910yx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24d4r910yx();
function getUrlParam(url, name) {
  cov_24d4r910yx().f[0]++;
  var sanitizedName = (cov_24d4r910yx().s[0]++, name.replace(/[[\]]/g, '\\$&'));
  var regex = (cov_24d4r910yx().s[1]++, new RegExp("[?&]".concat(sanitizedName, "(=([^&#]*)|&|#|$)")));
  var results = (cov_24d4r910yx().s[2]++, regex.exec(url));
  cov_24d4r910yx().s[3]++;
  if (!results) {
    cov_24d4r910yx().b[0][0]++;
    cov_24d4r910yx().s[4]++;
    return null;
  } else {
    cov_24d4r910yx().b[0][1]++;
  }
  cov_24d4r910yx().s[5]++;
  if (!results[2]) {
    cov_24d4r910yx().b[1][0]++;
    cov_24d4r910yx().s[6]++;
    return '';
  } else {
    cov_24d4r910yx().b[1][1]++;
  }
  cov_24d4r910yx().s[7]++;
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Return the string URL was build from params object
 * If the value of params is null or undefined, it would not appear in return URL
 * ex: ({ productId: 123, dateFrom: '2019-12-12', dateTo: null }, '')
 * => return 'productId=123&dataFrom=2019-12-12'
 * @param params - An object contain parameter key and value.
 * @param urlPath - URL path
 * @returns {string}
 */
cov_24d4r910yx().s[8]++;
var buildUrl = exports.buildUrl = function buildUrl() {
  var urlPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_24d4r910yx().b[2][0]++, '');
  var params = arguments.length > 1 ? arguments[1] : undefined;
  cov_24d4r910yx().f[1]++;
  cov_24d4r910yx().s[9]++;
  if ((cov_24d4r910yx().b[4][0]++, urlPath !== null) && (cov_24d4r910yx().b[4][1]++, typeof urlPath !== 'string')) {
    cov_24d4r910yx().b[3][0]++;
    cov_24d4r910yx().s[10]++;
    return '';
  } else {
    cov_24d4r910yx().b[3][1]++;
  }
  cov_24d4r910yx().s[11]++;
  if ((cov_24d4r910yx().b[6][0]++, !params) || (cov_24d4r910yx().b[6][1]++, (0, _size.default)(params) === 0)) {
    cov_24d4r910yx().b[5][0]++;
    cov_24d4r910yx().s[12]++;
    return urlPath;
  } else {
    cov_24d4r910yx().b[5][1]++;
  }
  var newUrl = (cov_24d4r910yx().s[13]++, urlPath === null ? (cov_24d4r910yx().b[7][0]++, '') : (cov_24d4r910yx().b[7][1]++, urlPath));
  cov_24d4r910yx().s[14]++;
  (0, _keys.default)(params).forEach(function (key) {
    cov_24d4r910yx().f[2]++;
    var paramValue = (cov_24d4r910yx().s[15]++, params[key]);
    cov_24d4r910yx().s[16]++;
    if ((cov_24d4r910yx().b[9][0]++, paramValue !== undefined) && (cov_24d4r910yx().b[9][1]++, paramValue !== null)) {
      cov_24d4r910yx().b[8][0]++;
      var pattern = (cov_24d4r910yx().s[17]++, new RegExp("\\b(".concat(key, "=).*?(&|#|$)")));
      cov_24d4r910yx().s[18]++;
      if ((cov_24d4r910yx().b[11][0]++, urlPath === '') || (cov_24d4r910yx().b[11][1]++, urlPath == null)) {
        cov_24d4r910yx().b[10][0]++;
        cov_24d4r910yx().s[19]++;
        newUrl = "".concat(newUrl).concat(newUrl === '' ? (cov_24d4r910yx().b[12][0]++, '') : (cov_24d4r910yx().b[12][1]++, '&')).concat(key, "=").concat(paramValue);
      } else {
        cov_24d4r910yx().b[10][1]++;
        cov_24d4r910yx().s[20]++;
        if (newUrl.search(pattern) >= 0) {
          cov_24d4r910yx().b[13][0]++;
          cov_24d4r910yx().s[21]++;
          newUrl = newUrl.replace(pattern, "$1".concat(paramValue, "$2"));
        } else {
          cov_24d4r910yx().b[13][1]++;
          cov_24d4r910yx().s[22]++;
          newUrl = newUrl.replace(/[?#]$/, '');
          cov_24d4r910yx().s[23]++;
          newUrl = "".concat(newUrl).concat(newUrl.indexOf('?') > 0 ? (cov_24d4r910yx().b[14][0]++, '&') : (cov_24d4r910yx().b[14][1]++, '?')).concat(key, "=").concat(paramValue);
        }
      }
    } else {
      cov_24d4r910yx().b[8][1]++;
    }
  });
  cov_24d4r910yx().s[24]++;
  return newUrl;
};